import ApiService from './api_services'

const NotificationApi = {
  getList: function(params) {
    return ApiService.get('/notifications', params)
  }
}

export default NotificationApi
